export const getAudioUploadsLocalStorageKey = (userId: Maybe<string>): string =>
    `${userId ?? 'no_user_id__'}.audioUploads`;
